import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Wrench, BarChart3, X, Presentation } from "lucide-react";
import { useLang } from "@/lib/i18n";

const TOUR_ITEMS = [
  { icon: Sparkles, key: "tour_match", to: "/matchmaker", testid: "tour-matchmaker-btn" },
  { icon: Wrench, key: "tour_planner", to: "/solusi?demo=1", testid: "tour-solusi-btn" },
  { icon: BarChart3, key: "tour_dashboard", to: "/organizer?report=1", testid: "tour-organizer-btn" },
];

export default function DemoTourBar() {
  const [minimized, setMinimized] = useState(false);
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();
  const { t } = useLang();

  useEffect(() => {
    const check = () => setHidden(Boolean(document.querySelector('[role="dialog"][data-state="open"]')));
    const obs = new MutationObserver(check);
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-state"] });
    check();
    return () => obs.disconnect();
  }, []);

  if (hidden) return null;

  if (minimized) {
    return (
      <button
        data-testid="tour-expand-btn"
        onClick={(e) => { e.stopPropagation(); setMinimized(false); }}
        aria-label="Buka Quick Demo Tour"
        className="print:hidden fixed bottom-4 right-4 z-40 flex items-center gap-2 bg-slate-900/90 backdrop-blur-md text-white text-xs font-bold px-4 py-2.5 rounded-full shadow-2xl border border-slate-700/50 hover:bg-slate-800 transition-colors"
      >
        <Presentation className="w-4 h-4 text-emerald-400" /> Demo Tour
      </button>
    );
  }

  return (
    <div
      data-testid="demo-tour-bar"
      onClick={(e) => e.stopPropagation()}
      className="print:hidden fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-4xl"
    >
      <div className="w-fit max-w-full mx-auto flex flex-nowrap items-center gap-2 px-4 py-2 bg-slate-900/90 backdrop-blur-md border border-slate-700/50 shadow-2xl rounded-full overflow-x-auto">
        <span className="hidden md:flex items-center gap-1.5 text-xs font-black text-emerald-400 uppercase tracking-wider shrink-0">
          <Presentation className="w-4 h-4" /> {t("tour_label")}
        </span>
        {TOUR_ITEMS.map((item) => (
          <button
            key={item.to}
            data-testid={item.testid}
            onClick={(e) => { e.stopPropagation(); navigate(item.to); }}
            className="flex items-center gap-1.5 whitespace-nowrap shrink-0 bg-white/10 hover:bg-emerald-600 text-white text-xs font-bold px-3.5 py-2 rounded-full border border-white/15 transition-colors"
          >
            <item.icon className="w-3.5 h-3.5" /> {t(item.key)}
          </button>
        ))}
        <button
          data-testid="tour-minimize-btn"
          onClick={(e) => { e.stopPropagation(); setMinimized(true); }}
          aria-label="Sembunyikan Demo Tour"
          className="p-2 min-w-[32px] min-h-[32px] flex items-center justify-center rounded-full text-slate-400 hover:text-white hover:bg-white/10 transition-colors shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

